//////LIBRARY//////
import React, { useEffect, useState, Fragment } from 'react'
import styled from 'styled-components'
import _, { cloneDeep, isEmpty, isUndefined, isEqual, map, find, isNull } from 'lodash'
import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import { useHistory, useRouteMatch } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import moment from 'moment'
//////COMPONENTS//////
import { uriList } from '../../routings/settings/RouteList'
import { kioskRacksRequestActionCreators } from '../../store/actions'
import userPrivileges from '../../constants/PrivilegesList'
import Modals from '../../components/Modals'
import Theme from '../../theme/theme'
import Button from '../../components/Ui/Buttons'
import {
	ButtonWrapper,
	PageWrapperLinks,
	PageWrapperActions,
	PageTitle,
	PageWrapperGrids,
	SpanTitle,
	LabelText,
	SelectInputWrapper,
	SelectInputCustom,
	OptionCustom,
	ErrorInputMsg,
} from '../../theme/GlobalCss'
import StringFormatter from '../../helpers/StringFormatter'
import Tooltip from '../../components/Tooltip/Tooltip'
import TooltipHelp from '../../components/TooltipHelp'
import { Controller, useForm } from 'react-hook-form'
import ToggleFilters from '../../components/Ui/ToggleFilters'
import TableNested from '../../components/Table/components/TableNested'
import allReplace from '../../helpers/allReplace'
/////////ASSETS/////////
import AddRack from '../../assets/icones/global/add.svg'
import ViewRackIcon from '../../assets/icones/global/view-white.svg'
import EditRackIcon from '../../assets/icones/global/edit-white.svg'
import DeleteRackIcon from '../../assets/icones/global/trash-white.svg'
import Validation from '../../assets/icones/global/check.svg'
import Cancel from '../../assets/icones/global/close-white.svg'

//////STYLED//////
const KioskRacksRequestWrapper = styled.div`
	position: relative;
`
const PageWrapperGridsCustom = styled(PageWrapperGrids)`
	grid-column-gap: 20px;
	& > div:last-child {
		border-right: none;
		padding-right: 0px;
	}
`
const KioskRacksRequestColumn = styled.div`
	font-size: ${(props) => props.theme.font.fs};
	border-right: 1px solid ${(props) => props.theme.colors.TabNav.border};
	padding-right: 20px;
	height: 100%;
`
const KioskRacksRequestTitlePart = styled.span`
	line-height: 32px;
	height: 32px;
	color: ${(props) => props.theme.colors.white};
	background-color: ${(props) => props.theme.colors.primary};
	display: block;
	padding-left: 15px;
	font-weight: bold;
	margin-bottom: 10px;
	margin-top: 10px;
`
const KioskRacksRequestContentPart = styled.div`
	display: grid;
	grid-row-gap: 20px;
	grid-template-columns: auto;
	padding: 0px 10px 10px 10px;
	margin-top: 10px;
`
const KioskRacksRequestInfo = styled.div`
	padding: 12px;
	background-color: ${(props) => (props.themed === 'white' ? 'transparent' : props.theme.infoPart.background)};
	border: ${(props) => (props.themed === 'white' ? `1px solid ${props.theme.infoPart.borderBlue}` : 'none')};
	& > div:first-child {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 10px;
	}
	& > div:first-child span {
		font-weight: bold;
		color: ${(props) => props.theme.colors.primary};
	}
	& > div:first-child img {
		cursor: pointer;
	}
`
const KioskRacksRequestRacksInfoPart = styled.ul`
	list-style-type: none;
	padding: 0px;
	& > li {
		font-weight: ${(props) => (props.level === 0 ? 'bold' : 'normal')};
	}
	& > li > div {
		display: grid;
		grid-template-columns: 55% 45%;
	}
	& > li > div > span:first-child {
		margin-left: ${(props) => (props.level > 0 ? `${props.level * 30}px` : `0px`)};
	}
	& > li > div > span:nth-child(2) {
		color: ${(props) => (props.level > 0 ? props.theme.text.colors.primary : props.theme.colors.primary)};
	}
`
const KioskRacksRequestRacksList = styled.div`
	display: grid;
	grid-template-columns: auto;
	grid-row-gap: 10px;
	margin: 10px 0px 0px 10px;
`
const KioskRacksRequestRackItem = styled.div`
	position: relative;
	border-radius: 24px;
	background-color: ${(props) => (props.disabled ? props.theme.colors.eraser : props.theme.colors.primary)};
	padding: 13px 21px;
	& > span {
		color: ${(props) => props.theme.colors.white};
	}
	display: grid;
	grid-template-columns: max-content auto max-content max-content max-content;
	grid-column-gap: 15px;
	align-items: center;
	& > div > img {
		cursor: pointer;
		max-height: 20px;
	}
	& > div > img.unusableIcon {
		opacity: 0.5;
		cursor: not-allowed;
	}
`
const KioskRacksRequestRackItemStatus = styled.div`
	width: 20px;
	height: 20px;
	background-color: ${(props) => props.requestStatus};
	position: absolute;
	border: 2px solid ${(props) => props.theme.colors.white};
	border-radius: 20px;
	left: -10px;
	top: 50%;
	transform: translateY(-50%);
`
const KioskCreationDefinitionBusinessRacksPart = styled.div`
	display: grid;
	grid-template-columns: auto max-content;
	grid-row-gap: 25px;
`
const KioskCreationDefinitionBusinessRacksPartAccessory = styled.div`
	margin: 0px 25px;
	& > div {
		display: grid;
		grid-template-columns: auto auto;
		grid-column-gap: 10px;
		grid-row-gap: 25px;
	}
`
const KioskRacksRequestStatusWrapper = styled.div`
	text-align: center;
	background-color: ${(props) => props.colorCode};
	color: ${(props) => props.theme.colors.white};
	line-height: 32px;
	font-weight: bold;
`
const TextModalWrapper = styled.div`
	display: grid;
	grid-row-gap: 20px;
`
//////STYLED//////

const KioskRacksRequest = (props) => {
	const { user, translations, userKioskPerimeter, kioskRacksRequest, userRolePrivileges, kioskProductionList } = useSelector(
		(state) => ({
			user: state.user,
			translations: state.languages.translations,
			userKioskPerimeter: state.user.identity.kioskSelected,
			kioskRacksRequest: state.kioskRacksRequest,
			userRolePrivileges: state.user.identity.rolePrivileges,
			kioskProductionList: state.kioskProductionList,
		}),
		shallowEqual
	)

	const history = useHistory()
	const match = useRouteMatch()

	// Default values of the form
	const [stateDefaultValuesModal, setStateDefaultValuesModal] = useState({ displayStandFolded: false, accessoryRack: false })

	const {
		register: registerModal,
		handleSubmit: handleSubmitModal,
		watch: watchModal,
		control: controlModal,
		errors: errorsModal,
		setValue: setValueModal,
		getValues: getValuesModal,
		reset: resetModal,
	} = useForm({
		defaultValues: stateDefaultValuesModal,
	})

	const columnsViewRack = [
		{ dataHook: 'request.type.label', headerName: translations['modal__admin__rackUpdate_detail_requiredAction'], isAuthorize: true },
		{
			dataHook: 'request.transmission.id',
			headerName: translations['modal__admin__rackUpdate_detail_transmissionStatus'],
			isAuthorize: true,
			component: (props) => (
				<KioskRacksRequestStatusWrapper colorCode={props.row.request.transmission.colorCode}>
					{translations[props.row.request.transmission.translationKey]}
				</KioskRacksRequestStatusWrapper>
			),
			tooltipHelp: { content: 'tooltip__admin__rackUpdate_disclaimer_one', insideModal: true },
		},
		{
			dataHook: 'request.dateAction',
			headerName: translations['modal__admin__rackUpdate_detail_dateRequested'],
			isAuthorize: true,
			component: (props) =>
				props.row.request.dateAction === null ? '-' : moment(props.row.request.dateAction).local().format('DD/MM/YYYY HH:mm'),
		},
		{
			dataHook: 'request.dateTransmission',
			headerName: translations['modal__admin__rackUpdate_detail_dateTransmited'],
			isAuthorize: true,
			component: (props) =>
				props.row.request.dateTransmission === null ? '-' : moment(props.row.request.dateTransmission).local().format('DD/MM/YYYY HH:mm'),
		},
		{
			dataHook: 'request.idRequest',
			headerName: translations['modal__admin__rackUpdate_detail_action'],
			isAuthorize: true,
			component: (props) => {
				// modal__admin__rackUpdate_request_cancel
				let buttonText = ''
				switch (props.row.request.type.id) {
					case 1:
						let text_1 = translations[props.row?.request?.type.translationKey].toLowerCase()
						buttonText = StringFormatter.ResponseMessageParser(translations['modal__admin__rackUpdate_request_cancel'], [text_1])
						break
					case 2:
						let text_2 = translations[props.row?.request?.type.translationKey].toLowerCase()
						buttonText = StringFormatter.ResponseMessageParser(translations['modal__admin__rackUpdate_request_cancel'], [text_2])
						break
					case 3:
						let text_3 = translations[props.row?.request?.type.translationKey].toLowerCase()
						buttonText = StringFormatter.ResponseMessageParser(translations['modal__admin__rackUpdate_request_cancel'], [text_3])
						break
				}
				/*props.row.request.type.id === 3 &&*/
				return (
					props.row.request.transmission.id === 1 && (
						<ButtonWrapper singleButton>
							<Button
								borderColor={Theme.colors.error}
								bgColor={Theme.colors.white}
								color={Theme.colors.error}
								text={buttonText}
								actionHandler={() => setShowModalConfirmCancelRequest(true)}
								disabled={isUndefined(find(userRolePrivileges.privileges, (o) => o.label === userPrivileges.action[26]))}
							/>
						</ButtonWrapper>
					)
				)
			},
		},
	]

	// Modals
	const [row, setRow] = useState()
	const [showModalAddRack, setShowModalAddRack] = useState(false)
	const [showModalViewRack, setShowModalViewRack] = useState(false)
	const [showModalConfirmCancelRequest, setShowModalConfirmCancelRequest] = useState(false)
	const [showModalConfirmDeleteRack, setShowModalConfirmDeleteRack] = useState(false)

	// Filters

	const [currentPerimeterKiosks, setCurrentPerimeterKiosks] = useState([])

	const actionsKioskRacksRequest = bindActionCreators(kioskRacksRequestActionCreators, useDispatch())

	// Added rack list
	const [addedRackList, setAddedRackList] = useState([])

	// Available racks
	const [availableRackList, setAvailableRackList] = useState([])

	// Selected rack
	const [selectedRack, setSelectedRack] = useState({})

	const [rackModalEditMode, setRackModalEditMode] = useState(false)

	// Recap racks object - business view => dynamic
	const [recapRack, setRecapRack] = useState({
		foldedList: [],
		notFoldedList: [],
		smallLockerNumbers: 0,
		mediumLockerNumbers: 0,
		largeLockerNumbers: 0,
		extraLargeLockerNumbers: 0,
	})

	/////////////////////////////// HANDLER //////////////////////////////////////

	const extractRacksInformations = (mode = 'customer') => {
		const extractData = kioskRacksRequest.item.displayStandsInformation

		// Getting racks information
		let notFoldedList = []
		extractData.displayStandTypes[0].displayStandModel.forEach((elem) => {
			let elemToAdd = {}
			if (elem.displayStandTypeModelNumber > 0) {
				const obj = find(kioskRacksRequest.item.details, (o) => o.rackModel === elem.displayStandModel)
				if (!isUndefined(obj)) {
					elemToAdd.id = obj.idRack
					elemToAdd.label = translations[obj.rackModel]
					elemToAdd.count = elem.displayStandTypeModelNumber
					notFoldedList.push(elemToAdd)
				}
			}
		})

		let foldedList = []
		extractData.displayStandTypes[1].displayStandModel.forEach((elem) => {
			let elemToAdd = {}
			if (elem.displayStandTypeModelNumber > 0) {
				const obj = find(kioskRacksRequest.item.details, (o) => o.rackModel === elem.displayStandModel)
				if (!isUndefined(obj)) {
					elemToAdd.id = obj.idRack
					elemToAdd.label = translations[obj.rackModel]
					elemToAdd.count = elem.displayStandTypeModelNumber
					foldedList.push(elemToAdd)
				}
			}
		})
		return {
			foldedList: foldedList,
			notFoldedList: notFoldedList,
			smallLockerNumbers: extractData.smallLockerNumber,
			mediumLockerNumbers: extractData.mediumLockerNumber,
			largeLockerNumbers: extractData.largeLockerNumber,
			extraLargeLockerNumbers: extractData.extraLargeLockerNumber,
			//accessoriesList: accessoriesList,
		}
	}

	const handleCloseModals = () => {
		if (showModalAddRack) {
			setShowModalAddRack(false)
			setRow()
			setSelectedRack({})
			setAvailableRackList([])
			resetModal()
			setRackModalEditMode(false)
		}
		if (showModalViewRack) {
			setShowModalViewRack(false)
			setRow()
			setSelectedRack({})
			setAvailableRackList([])
			resetModal()
		}
		if (showModalConfirmCancelRequest) {
			setShowModalConfirmCancelRequest(false)
		}
		if (showModalConfirmDeleteRack) {
			setShowModalConfirmDeleteRack(false)
		}
	}

	const handleChangeRack = (idRack) => {
		let rack = find(availableRackList, { id: parseInt(idRack) })
		if (isUndefined(rack.displayStandFolded)) rack.displayStandFolded = false
		// If accessory fields exists, it means that we CAN add accessory, but it is not mandatory
		// In this case, we set it on false by default
		if (!isUndefined(rack.accessoryRack)) rack.accessoryRack = false
		setSelectedRack(rack)
	}

	// When changing rack model switch
	const handleRackModelSelectedChange = (switchElem) => {
		let rack = cloneDeep(selectedRack)

		switch (switchElem) {
			case 'displayStandFolded':
				rack.displayStandFolded = !rack.displayStandFolded
				break
			/*case "solar":
				rack.solar = !rack.solar
				break;*/
			case 'accessoryRack':
				rack.accessoryRack = !rack.accessoryRack
				break
			default:
				break
		}
		setSelectedRack(rack)
	}

	const onSubmitModal = (data) => {
		const datas = cloneDeep(data)
		setRackModalEditMode(false)
		const submittedData = {
			idDisplayStandModel: rackModalEditMode ? selectedRack.id : datas.idDisplayStandModel,
			displayStandName: `Rack ${selectedRack.label}`,
			displayStandFolded: selectedRack.displayStandFolded,
			isMain: selectedRack.isMain,
			allowAccessoryRack: selectedRack.allowAccessoryRack,
			allowMultiMain: selectedRack.allowMultiMain,
			accessories: selectedRack.accessoryRack
				? [
						{
							idAccessoryLockersNumber: datas.idAccessoryLockersNumber,
							idAccessoryDisplayStandModel: datas.idAccessoryDisplayStandModel,
							quantity: datas.quantity,
						},
				  ]
				: [],
		}
		!isUndefined(row)
			? !isNull(row?.request)
				? actionsKioskRacksRequest.postKioskRacksRequestUpdateRequest(row?.request.idRequest, submittedData)
				: actionsKioskRacksRequest.postKioskRacksRequestUpdateRack(row?.idRack, submittedData)
			: actionsKioskRacksRequest.postKioskRacksRequestAddRack(match.params.id, submittedData)
	}

	// When user is clicking edit rack icon
	const handleEditRack = (elem) => {
		setShowModalAddRack(true)
		setRow(elem)
	}

	// When user is clicking view rack icon
	const handleViewRack = (elem) => {
		setShowModalViewRack(true)
		setRow(elem)
	}

	const handleDeleteRequest = () => {
		actionsKioskRacksRequest.putKioskRacksRequestDeleteRequest(row?.request?.idRequest)
		//setShowModalConfirmCancelRequest(false)
	}

	// When user is clicking delete rack icon
	const handleDeleteRack = (elem) => {
		setRow(elem)
		setShowModalConfirmDeleteRack(true)
	}

	// When user confirms deleting rack
	const handleSubmitDeleteRack = () => {
		actionsKioskRacksRequest.putKioskRacksRequestDeleteRack(row?.idRack)
	}

	/////////////////////////////// USE EFFECT //////////////////////////////////////

	useEffect(() => {
		return function cleanUp() {
			actionsKioskRacksRequest.resetDataKioskRacksRequest()
		}
	}, [])

	// On loading page
	useEffect(() => {
		if (isEmpty(translations)) return
		if (isEqual(kioskRacksRequest.item, {})) actionsKioskRacksRequest.getKioskRacksRequest(match.params.id)
	}, [user, translations])

	// Actions after loading kiosk data
	useEffect(() => {
		if (!isEmpty(kioskRacksRequest.item)) {
			setRecapRack(extractRacksInformations())
			setAddedRackList(kioskRacksRequest.item.details)
		}
	}, [kioskRacksRequest, translations])

	// If user is changing his perimeter, we need to make a back call
	useEffect(() => {
		if (!isEqual(userKioskPerimeter, currentPerimeterKiosks) && !isEmpty(currentPerimeterKiosks))
			actionsKioskRacksRequest.getKioskRacksRequest(match.params.id)
		setCurrentPerimeterKiosks(userKioskPerimeter)
	}, [userKioskPerimeter])

	// On opening form modal
	useEffect(() => {
		if (showModalAddRack) {
			actionsKioskRacksRequest.getKioskRacksRequestForm()
		}
	}, [showModalAddRack])

	// After loading data form modal
	useEffect(() => {
		if (!isEqual(kioskRacksRequest.options, {})) setAvailableRackList(kioskRacksRequest.options)
	}, [kioskRacksRequest.options])

	// After updating form modal (create or edit)
	useEffect(() => {
		if (kioskRacksRequest.isUpdated && showModalAddRack) {
			setShowModalAddRack(false)
			setRow()
			setSelectedRack({})
			setAvailableRackList([])
			resetModal()
		}
		if (kioskRacksRequest.isUpdated && showModalConfirmCancelRequest) {
			setShowModalConfirmCancelRequest(false)
			setShowModalViewRack(false)
			setRow()
		}
		if (kioskRacksRequest.isUpdated && showModalConfirmDeleteRack) {
			setShowModalConfirmDeleteRack(false)
			setRow()
		}
	}, [kioskRacksRequest.isUpdated])

	// On editing rack (icon clicked)
	useEffect(() => {
		if (!isUndefined(row) && showModalAddRack && !isEmpty(availableRackList)) {
			// Searching by label might not be the good answer
			let rack = find(availableRackList, { translationKey: row?.rackModel })
			rack.displayStandFolded = row?.folded
			rack.accessoryRack = !isEmpty(row?.accessoriesRack)
			setSelectedRack(rack)
		}
	}, [row, showModalAddRack, availableRackList])

	// Updating form values on edit
	useEffect(() => {
		if (!isUndefined(row) && showModalAddRack && !isEmpty(availableRackList) && !isEqual(selectedRack, {})) {
			setValueModal('idDisplayStandModel', selectedRack.id)
			if (!isEmpty(row?.accessoriesRack)) {
				// Always at this value, until customer asking changes
				setValueModal('idAccessoryLockersNumber', 1)
				setValueModal('quantity', row?.accessoriesRack[0].quantity)
			}
			if (row?.request?.transmission.id > 1 || row?.request?.type.id === 2 || isNull(row?.request)) {
				setRackModalEditMode(true)
			}
		}
	}, [row, showModalAddRack, availableRackList, selectedRack])

	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<Fragment>
			<Modals
				title={`${translations['modal__admin__rackUpdate_detail_title']} ${row?.rackLabel}`}
				showModal={showModalViewRack}
				closeModalHandler={handleCloseModals}
				icon={true}
			>
				<TextModalWrapper>
					<TableNested inputConfig={{ actions: {}, nestedTheme: false }} inputData={[row]} inputColumns={columnsViewRack} />
					<ButtonWrapper singleButton>
						<Button
							actionHandler={handleCloseModals}
							text={translations['common__text__ok']}
							bgColor={Theme.colors.validation}
							img={Validation}
						/>
					</ButtonWrapper>
				</TextModalWrapper>
			</Modals>
			<Modals
				title={`${
					!isUndefined(row) &&
					!isNull(row?.request) &&
					translations &&
					StringFormatter.ResponseMessageParser(translations['modal__admin__rackUpdate_request_cancel'], [
						translations[row?.request.type.translationKey].toLowerCase(),
					])
				} ${row?.rackLabel}`}
				showModal={showModalConfirmCancelRequest}
				closeModalHandler={() => setShowModalConfirmCancelRequest(false)}
				icon={true}
				level="error"
			>
				<TextModalWrapper>
					<span>
						{`${
							!isUndefined(row) &&
							!isNull(row?.request) &&
							translations &&
							StringFormatter.ResponseMessageParser(translations['modal__admin__rackUpdate_request_cancel_confirmation'], [
								translations[row?.request.type.translationKey].toLowerCase(),
							])
						} ${row?.rackLabel} ?`}
					</span>
					<ButtonWrapper>
						<Button
							actionHandler={() => setShowModalConfirmCancelRequest(false)}
							text={translations['common__text__cancel']}
							bgColor={Theme.colors.error}
							margin="true"
							img={Cancel}
						/>
						<Button
							actionHandler={() => handleDeleteRequest()}
							text={translations['common__text__validate']}
							bgColor={Theme.colors.validation}
							img={Validation}
						/>
					</ButtonWrapper>
				</TextModalWrapper>
			</Modals>
			<Modals
				title={translations['modal__admin__rackUpdate_request_deletion_title']}
				showModal={showModalConfirmDeleteRack}
				closeModalHandler={handleCloseModals}
				icon={true}
				level="error"
			>
				<TextModalWrapper>
					<p
						dangerouslySetInnerHTML={{
							__html: StringFormatter.ResponseMessageParser(
								allReplace(
									row?.hasItemInLockers
										? translations['modal__admin__rackUpdate_request_deletion_body']
										: translations['modal__admin__rackUpdate_request_deletion_body_confirm'],
									'\\\\n',
									'<br>'
								),
								[`<span style="color:${Theme.colors.primary};">${row?.rackLabel}</span>`]
							),
						}}
					></p>
					<ButtonWrapper>
						<Button
							actionHandler={handleCloseModals}
							text={translations['common__text__cancel']}
							bgColor={Theme.colors.error}
							margin="true"
							img={Cancel}
						/>
						<Button
							actionHandler={() => handleSubmitDeleteRack()}
							text={translations['common__text__validate']}
							bgColor={Theme.colors.validation}
							img={Validation}
						/>
					</ButtonWrapper>
				</TextModalWrapper>
			</Modals>
			<Modals
				title={translations['modal__admin__rackUpdate_information_title']}
				showModal={showModalAddRack && !isEmpty(availableRackList)}
				closeModalHandler={handleCloseModals}
				icon={true}
				width={500}
			>
				<KioskRacksRequestContentPart>
					<KioskCreationDefinitionBusinessRacksPart>
						<Fragment>
							<div>
								<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_rackModel']}* :</LabelText>
							</div>
							<div>
								<SelectInputWrapper>
									<SelectInputCustom
										width="208"
										name="idDisplayStandModel"
										ref={registerModal({
											required: {
												value: true,
												message: translations['common__text__requiredField'],
											},
											validate: (value) => value > 0 || translations['common__text__requiredField'],
										})}
										className={watchModal('idDisplayStandModel') > 0 ? 'active' : ''}
										onChange={(e) => handleChangeRack(e.target.value)}
										disabled={rackModalEditMode}
									>
										<OptionCustom value="0" hidden>
											{translations['page_admin_initKiosk_stepOne_sheet_rackModel_placeholder']}
										</OptionCustom>
										{map(availableRackList, (elem, id) => {
											const mainRackCount = _.countBy(addedRackList, (o) => o.isMain)
											const multiMainRackCount = _.countBy(addedRackList, (o) => o.allowMultiMain)

											//const secondaryAvailable = ((!isUndefined(mainRackCount.true) && !isUndefined(multiMainRackCount.true)) && mainRackCount.true > multiMainRackCount.true) ? true : false

											return (
												<OptionCustom
													key={id}
													value={elem.id}
													target={true}
													//hidden={((isEmpty(addedRackList) && !elem.isMain)) || (!secondaryAvailable && !elem.isMain)}
													hidden={
														(!isUndefined(mainRackCount.true) && isUndefined(multiMainRackCount.true) && elem.isMain) ||
														(!isUndefined(multiMainRackCount.true) && elem.isMain && !elem.allowMultiMain) ||
														(!elem.isMain &&
															isUndefined(mainRackCount.true)) /* || !isUndefined(multiMainRackCount.true)*/
													}
												>
													{translations[elem.translationKey]}
												</OptionCustom>
											)
										})}
									</SelectInputCustom>
								</SelectInputWrapper>
								{errorsModal.idDisplayStandModel && <ErrorInputMsg>{errorsModal.idDisplayStandModel.message}</ErrorInputMsg>}
							</div>
						</Fragment>
					</KioskCreationDefinitionBusinessRacksPart>
					<KioskCreationDefinitionBusinessRacksPart>
						{!isEqual(selectedRack, {}) && (
							<Fragment>
								<div>
									<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_foldable']} :</LabelText>
								</div>
								<div>
									<Controller
										control={controlModal}
										name="displayStandFolded"
										as={ToggleFilters}
										size="large"
										checked={selectedRack.displayStandFolded}
										reverseCheck
										onChangeHandler={() => {
											handleRackModelSelectedChange('displayStandFolded')
										}}
										rules={registerModal({
											required: {
												value: false,
												message: translations['common__text__requiredField'],
											},
										})}
										disabled
										labelPrev={translations['common__text__yes']}
										labelNext={translations['common__text__no']}
									/>
								</div>
								<div>
									<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_accessoryModule']} :</LabelText>
								</div>
								<div>
									<Controller
										control={controlModal}
										name="accessoryRack"
										as={ToggleFilters}
										disabled={!selectedRack.allowAccessoryRack}
										size="large"
										checked={selectedRack.accessoryRack}
										reverseCheck
										onChangeHandler={() => {
											handleRackModelSelectedChange('accessoryRack')
										}}
										rules={registerModal({
											required: {
												value: false,
												message: translations['common__text__requiredField'],
											},
										})}
										labelPrev={translations['common__text__yes']}
										labelNext={translations['common__text__no']}
									/>
								</div>
							</Fragment>
						)}
					</KioskCreationDefinitionBusinessRacksPart>
					{selectedRack.accessoryRack && (
						<Fragment>
							<KioskCreationDefinitionBusinessRacksPartAccessory>
								<div>
									<div>
										<LabelText>{`${translations['page__admin__rackUpdate_sheet_accessory_moodule_number']}* :`}</LabelText>
									</div>
									<div>
										<SelectInputWrapper>
											<SelectInputCustom
												width="208"
												name="quantity"
												ref={registerModal({
													required: {
														value: true,
														message: translations['common__text__requiredField'],
													},
													validate: (value) => value > 0 || translations['common__text__requiredField'],
												})}
												className={watchModal('idAccessoryLockersNumber') > 0 ? 'active' : ''}
											>
												<OptionCustom value="0" hidden>
													{translations['page__admin__rackUpdate_sheet_accessory_moodule_number_placeholder']}
												</OptionCustom>
												{map([1, 2, 3, 4, 5, 6], (elem, id) => {
													return (
														<OptionCustom key={id} value={elem} target={true}>
															{elem}
														</OptionCustom>
													)
												})}
											</SelectInputCustom>
										</SelectInputWrapper>
										{errorsModal.quantity && <ErrorInputMsg>{errorsModal.quantity.message}</ErrorInputMsg>}
									</div>
									<div>
										<LabelText>{`${translations['page_admin_initKiosk_stepOne_sheet_rackNumber']}* :`}</LabelText>
									</div>
									<div>
										<SelectInputWrapper>
											<SelectInputCustom
												width="208"
												name="idAccessoryLockersNumber"
												ref={registerModal({
													required: {
														value: true,
														message: translations['common__text__requiredField'],
													},
													validate: (value) => value > 0 || translations['common__text__requiredField'],
												})}
												className={watchModal('idAccessoryLockersNumber') > 0 ? 'active' : ''}
											>
												<OptionCustom value="0" hidden>
													{translations['page_admin_initKiosk_stepOne_sheet_rackNumber_placeholder']}
												</OptionCustom>
												{map(selectedRack.accessoryDisplayLockersNumber, (elem, id) => {
													return (
														<OptionCustom key={id} value={elem.id} target={true} selected={elem.selected}>
															{translations[elem.translationKey]}
														</OptionCustom>
													)
												})}
											</SelectInputCustom>
										</SelectInputWrapper>
										{errorsModal.idAccessoryLockersNumber && (
											<ErrorInputMsg>{errorsModal.idAccessoryLockersNumber.message}</ErrorInputMsg>
										)}
									</div>
									<div>
										<LabelText>{`${translations['page_admin_initKiosk_stepOne_sheet_accessoryLockerType']}* :`}</LabelText>
									</div>
									<div>
										<SelectInputWrapper>
											<SelectInputCustom
												width="208"
												name="idAccessoryDisplayStandModel"
												ref={registerModal({
													required: {
														value: true,
														message: translations['common__text__requiredField'],
													},
													validate: (value) => value > 0 || translations['common__text__requiredField'],
												})}
												className={watchModal('idAccessoryDisplayStandModel') > 0 ? 'active' : ''}
											>
												<OptionCustom value="0" hidden>
													{translations['page_admin_initKiosk_stepOne_sheet_accessoryLockerType_placeholder']}
												</OptionCustom>
												{map(selectedRack.accessoryDisplayStandModels, (elem, id) => {
													return (
														<OptionCustom key={id} value={elem.id} target={true} selected={elem.selected}>
															{translations[elem.translationKey]}
														</OptionCustom>
													)
												})}
											</SelectInputCustom>
										</SelectInputWrapper>
										{errorsModal.idAccessoryDisplayStandModel && (
											<ErrorInputMsg>{errorsModal.idAccessoryDisplayStandModel.message}</ErrorInputMsg>
										)}
									</div>
								</div>
							</KioskCreationDefinitionBusinessRacksPartAccessory>
						</Fragment>
					)}
				</KioskRacksRequestContentPart>
				<ButtonWrapper>
					<Button
						actionHandler={handleCloseModals}
						text={translations['common__text__cancel']}
						bgColor={Theme.colors.error}
						margin="true"
						img={Cancel}
					/>
					<Button
						actionHandler={handleSubmitModal(onSubmitModal)}
						text={translations['common__text__validate']}
						bgColor={Theme.colors.validation}
						img={Validation}
					/>
				</ButtonWrapper>
			</Modals>
			<KioskRacksRequestWrapper>
				<PageWrapperLinks>
					<Button
						goBack
						weight="bold"
						actionHandler={() => {
							history.push(`${uriList.kiosksInProduction}${uriList.kioskProductionList}`)
						}}
						text={translations['common__text__previousPage']}
					/>
				</PageWrapperLinks>
				<PageWrapperActions absolute outFramed withPageLinks>
					{/* <Tooltip tooltipId={'kioskRacksRequestSubmit'} translationsKey={'tooltip__admin__rackUpdate_saveRequest'}>
						<PageWrapperActionValidate type="submit" />
					</Tooltip> */}
					<Button
						text={translations['page__admin__rackUpdate_addRack']}
						bgColor={Theme.colors.primary}
						height={32}
						iconHeight={15}
						img={AddRack}
						actionHandler={() => {
							setShowModalAddRack(true)
							setRackModalEditMode(false)
						}}
						disabled={isUndefined(find(userRolePrivileges.privileges, (o) => o.label === userPrivileges.action[26]))}
					/>
				</PageWrapperActions>

				{!isEqual(kioskRacksRequest?.item, {}) ? (
					<TooltipHelp content={'tooltip__admin__rackUpdate_disclaimer_two'}>
						<PageTitle>{`${translations['page__admin__rackUpdate_page_title']} ${kioskRacksRequest?.item?.owner} ${kioskRacksRequest?.item?.kioskCode} ${kioskRacksRequest?.item?.kioskName}`}</PageTitle>
					</TooltipHelp>
				) : (
					<TooltipHelp content={'tooltip__admin__rackUpdate_disclaimer_two'}>
						<PageTitle>{translations['page__admin__rackUpdate_page_title']} </PageTitle>
					</TooltipHelp>
				)}

				<PageWrapperGridsCustom grids={4}>
					<KioskRacksRequestColumn>
						<KioskRacksRequestTitlePart>{translations['page_admin_initKiosk_stepOne_sheet_rackInformation']}</KioskRacksRequestTitlePart>
						<KioskRacksRequestContentPart>
							<KioskRacksRequestInfo themed="white">
								<div>
									<span>{translations['page_admin_initKiosk_stepOne_sheet_requestedRacks_resume']}</span>
								</div>
								<div>
									<KioskRacksRequestRacksInfoPart level={0}>
										<li>
											<div>
												<span>{translations['page_admin_initKiosk_stepOne_sheet_rackNumber']} :</span>
												{addedRackList.length > 0 && <span>{addedRackList.length}</span>}
											</div>
										</li>
										<li>
											<KioskRacksRequestRacksInfoPart level={1}>
												<li>
													<div>
														<span>{translations['page_admin_initKiosk_stepOne_sheet_whoseFoldable']} :</span>{' '}
														<span></span>
													</div>
													<KioskRacksRequestRacksInfoPart level={2}>
														{map(recapRack.foldedList, (elem) => (
															<li>
																<div>
																	<span>
																		{translations['page_admin_initKiosk_stepOne_sheet_whose']} {elem.label}
																	</span>{' '}
																	<span>{elem.count}</span>
																</div>
															</li>
														))}
													</KioskRacksRequestRacksInfoPart>
												</li>
												<li>
													<div>
														<span>{translations['page_admin_initKiosk_stepOne_sheet_whoseUnfoldable']} :</span>{' '}
														<span></span>
													</div>
													<KioskRacksRequestRacksInfoPart level={2}>
														{map(recapRack.notFoldedList, (elem) => (
															<li>
																<div>
																	<span>
																		{translations['page_admin_initKiosk_stepOne_sheet_whose']} {elem.label}
																	</span>{' '}
																	<span>{elem.count}</span>
																</div>
															</li>
														))}
													</KioskRacksRequestRacksInfoPart>
												</li>
											</KioskRacksRequestRacksInfoPart>
										</li>
									</KioskRacksRequestRacksInfoPart>
									<KioskRacksRequestRacksInfoPart level={0}>
										<li>
											<div>
												<span>{translations['page_admin_initKiosk_stepOne_sheet_lockersNumber']} :</span>
												{(recapRack.smallLockerNumbers > 0 ||
													recapRack.mediumLockerNumbers > 0 ||
													recapRack.largeLockerNumbers > 0 ||
													recapRack.extraLargeLockerNumbers > 0) && (
													<span>
														{recapRack.smallLockerNumbers +
															recapRack.mediumLockerNumbers +
															recapRack.largeLockerNumbers +
															recapRack.extraLargeLockerNumbers}
													</span>
												)}
											</div>
										</li>
										<KioskRacksRequestRacksInfoPart level={1}>
											<li>
												<div>
													<span>{translations['page_admin_initKiosk_stepOne_sheet_accessory_locker']} :</span>
													{recapRack.smallLockerNumbers > 0 && <span>{recapRack.smallLockerNumbers}</span>}
												</div>
											</li>
											<li>
												<div>
													<span>{translations['page_admin_initKiosk_stepOne_sheet_smallBottle_locker']} :</span>
													{recapRack.mediumLockerNumbers > 0 && <span>{recapRack.mediumLockerNumbers}</span>}
												</div>
											</li>
											<li>
												<div>
													<span>{translations['page_admin_initKiosk_stepOne_sheet_mediumBottle_locker']} :</span>
													{recapRack.largeLockerNumbers > 0 && <span>{recapRack.largeLockerNumbers}</span>}
												</div>
											</li>
											<li>
												<div>
													<span>{translations['page_admin_initKiosk_stepOne_sheet_largeBottle_locker']} :</span>
													{recapRack.extraLargeLockerNumbers > 0 && <span>{recapRack.extraLargeLockerNumbers}</span>}
												</div>
											</li>
										</KioskRacksRequestRacksInfoPart>
									</KioskRacksRequestRacksInfoPart>
									{/*<KioskRacksRequestRacksInfoPart level={0}>
											<li>
												<div><span>{translations['page_admin_initKiosk_stepOne_sheet_accessory_locker']}</span>
												{recapRack.accessoriesList.length > 0 &&
													renderAccessoriesCount()
												}
												</div>
											</li>
											<KioskRacksRequestRacksInfoPart level={1}>
												{
													map(recapRack.accessoriesList, elem => (
														<li>
															<div><span>{translations['page_admin_initKiosk_stepOne_sheet_whose']} {elem.label}</span> <span>{elem.countRacks*elem.count}</span></div>
														</li>
													))
												}
											</KioskRacksRequestRacksInfoPart>
										</KioskRacksRequestRacksInfoPart>*/}
								</div>
							</KioskRacksRequestInfo>
						</KioskRacksRequestContentPart>
					</KioskRacksRequestColumn>
					<KioskRacksRequestColumn style={{ paddingTop: '65px', height: 'auto' }}>
						<SpanTitle>{translations['page__admin__rackUpdate_page_secondTitle']}</SpanTitle>
						{!isEmpty(addedRackList) && (
							<KioskRacksRequestRacksList>
								{map(addedRackList, (elem, key) => {
									/* 	let isNotEditable = ""
										if (!isNull(elem.request)) {
											isNotEditable = !isUndefined(find(userRolePrivileges.privileges, (o) => o.label === userPrivileges.action[27])) &&
												elem.request.transmission.id > 1
										} */
									const isEditable =
										!isUndefined(find(userRolePrivileges.privileges, (o) => o.label === userPrivileges.action[26])) &&
										(isNull(elem.request) || (elem.request.transmission.id <= 1 && elem.request.type.id < 3))
									const isRemovable =
										!isUndefined(find(userRolePrivileges.privileges, (o) => o.label === userPrivileges.action[26])) &&
										!(!isNull(elem.request) /* && elem.request.type.id === 3*/)
									const labelAccessory = !isEmpty(elem?.accessoriesRack)
										? `${elem.accessoriesRack[0].type} x${elem.accessoriesRack[0].quantity}`
										: ''
									return (
										<KioskRacksRequestRackItem
										/*disabled={!isEditable}*/
										>
											{!isNull(elem.request) && (
												<Tooltip
													tooltipId={`kioskRacksRequest_${key}_StatusRack`}
													translationsKey={elem.request.transmission.translationKey}
												>
													<KioskRacksRequestRackItemStatus requestStatus={elem.request.transmission.colorCode} />
												</Tooltip>
											)}
											<span>{`Rack ${elem?.rackLabel}`}</span>
											<span>{`${translations[elem?.rackModel]}${labelAccessory.length > 0 ? '/' : ''}${labelAccessory}`}</span>
											{!isNull(elem.request) && (
												<Tooltip
													tooltipId={`kioskRacksRequest_${key}_transmissionStatus`}
													translationsKey={'tooltip__admin__rackUpdate_transmissionStatus'}
												>
													<img src={ViewRackIcon} onClick={() => !isNull(elem.request) && handleViewRack(elem)} />
												</Tooltip>
											)}
											{
												<Tooltip
													tooltipId={`kioskRacksRequest_${key}_EditRack`}
													translationsKey={'tooltip__admin__rackUpdate_editRack'}
												>
													<img
														src={EditRackIcon}
														className={!isEditable ? 'unusableIcon' : ''}
														onClick={() => isEditable && handleEditRack(elem)}
													/>
												</Tooltip>
											}
											{
												<Tooltip
													tooltipId={`kioskRacksRequest_${key}_DeleteRack`}
													translationsKey={'tooltip__admin__rackUpdate_deleteRack'}
												>
													<img
														src={DeleteRackIcon}
														className={!isRemovable ? 'unusableIcon' : ''}
														onClick={() => isRemovable && handleDeleteRack(elem)}
													/>
												</Tooltip>
											}
										</KioskRacksRequestRackItem>
									)
								})}
							</KioskRacksRequestRacksList>
						)}
					</KioskRacksRequestColumn>
				</PageWrapperGridsCustom>
			</KioskRacksRequestWrapper>
		</Fragment>
	)
}

KioskRacksRequest.propTypes = {}

KioskRacksRequest.defaultPropTypes = {}

export default KioskRacksRequest
